// 获取当前时间并转成月份，星期
export default () => {
  const dateTime = new Date()
  const year = dateTime.getFullYear()
  const month = dateTime.getMonth() + 1
  const day = dateTime.getDate()
  const hour = dateTime.getHours() < 10 ? '0' + dateTime.getHours() : dateTime.getHours()
  const minute = dateTime.getMinutes() < 10 ? '0' + dateTime.getMinutes() : dateTime.getMinutes()
  const second = dateTime.getSeconds() < 10 ? '0' + dateTime.getSeconds() : dateTime.getSeconds()
  // 星期
  const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  const weekDay = weekDays[dateTime.getDay()]

  return { dateTime: `${year}-${month}-${day} ${weekDay} ${hour}:${minute}:${second}`, date: `${year}年${month < 10 ? '0' + month : month}月${day < 10 ? '0' + day : day}日`, weekday: weekDay, year: year, month: month, day: day }
}
